import { useCallback, useEffect, useRef, useState } from "react";
import { acquirePageScrollLock, releasePageScrollLock } from "./usePageScrollLock";

type FilterDropdownOptions = {
  enabled?: boolean;
  paperClass?: string;
  listClass?: string;
};

let activeSidebarLocks = 0;

function lockSidebar() {
  if (activeSidebarLocks === 0) {
    document.querySelector<HTMLElement>(".sidebar")?.classList.add("filter-dropdown-open");
  }
  activeSidebarLocks += 1;
}

function unlockSidebar() {
  activeSidebarLocks = Math.max(0, activeSidebarLocks - 1);
  if (activeSidebarLocks === 0) {
    document.querySelector<HTMLElement>(".sidebar")?.classList.remove("filter-dropdown-open");
  }
}

export function useFilterDropdown({
  enabled = true,
  paperClass = "filter-dropdown-menu",
  listClass = "filter-dropdown-menu-list",
}: FilterDropdownOptions = {}) {
  const [open, setOpen] = useState(false);
  const lockedRef = useRef(false);

  const unlock = useCallback(() => {
    if (!lockedRef.current) return;
    lockedRef.current = false;
    releasePageScrollLock();
    unlockSidebar();
  }, []);

  const onOpen = useCallback(() => {
    if (enabled && !lockedRef.current) {
      acquirePageScrollLock();
      lockSidebar();
      lockedRef.current = true;
    }
    setOpen(true);
  }, [enabled]);

  const onClose = useCallback(() => {
    setOpen(false);
    unlock();
  }, [unlock]);

  useEffect(() => unlock, [unlock]);

  return {
    open,
    onOpen,
    onClose,
    MenuProps: {
      disableScrollLock: enabled,
      classes: { paper: paperClass },
      slotProps: { list: { className: listClass } },
    },
  };
}
